import { calculateHexSizeBasedOnWidth } from './shapes/hexagon/calculate-hex-size-based-on-width.js';

export function calculateTileHeight(
  shape: 'circle' | 'square' | 'hexagon',
  candidateWidth: number,
) {
  return shape === 'hexagon'
    ? calculateHexSizeBasedOnWidth(candidateWidth).height
    : candidateWidth;
}
